export const PROVIDE_KEY = "provideKey";
export const DEFAULT_OPTIONS = {
  format: "webp",
  rt: "fill",
  el: true
};
export const DEFAULT_BASE_URL = "https://cdn0.it4profit.com/s3";
export const PROXY_PREFIX = "size";
